function pw_post_product_modal_save(personalisationID, thumbURL){
  replaceImage(thumbURL);
}

function replaceImage(thumbURL){
  
  $(".p-thumb.images .img_ptw").attr("data-src", thumbURL);
  $(".p-thumb.images .img_ptw").attr("data-bgset", thumbURL);
  
  $(".p-thumb.images .img_ptw").css("background-image", 'url(' + thumbURL + ')');
}


$( document ).ready(function() {
  
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");

     if ($("body").hasClass("template-product") && (pw_button.length || staticProduct.length) ){
       $(".shopify-payment-button").hide();
     }

    if ($("body").hasClass("template-product") && pw_button.length){

      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();

      function pwVariationChange(){

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();

          if(pw_button_text == "Edit"){

            
            var product_image_original = $('meta[property="og:image"]').attr('content');
            
            console.log(product_image_original);
            
            
            $(".p-thumb.images .img_ptw").attr("data-src", product_image_original);
            $(".p-thumb.images .img_ptw").attr("data-bgset", product_image_original);
            $(".p-thumb.images .img_ptw").css("background-image", 'url(' + product_image_original + ')');
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').val('Personalise');
            }


            setTimeout(function(){ 
              $(".shopify-payment-button, .pwAddToCart").hide();
            },1000);
          }
        }

      }
      $(".swatches-select .swatch__value_pr").on("click", function(e){
        console.log("test");
        pwVariationChange();
        setTimeout(function(){ 
        	 $(".shopify-payment-button, .pwAddToCart").hide();
        },1000);
      });

    }
  
  	function pwSidebarCart(){
      
       setTimeout(function(){ 
       
         var textArray = $(".mini_cart_item .mini_cart_info .mini_cart_meta:contains('PersonalisationID')");

          textArray.each(function() {

            var cardID = this.innerText.match(/PersonalisationID:.*/);
            cardID = cardID[0];
            cardID = cardID.replace("PersonalisationID:", "").trim();
            cardID = cardID.match(/[^\s]+/);
            cardID = cardID[0];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/270/"+cardID+".jpg?r="+rand;
            $(this).parent().parent().find("img").attr("src",newSrc);
            $(this).parent().parent().find("img").attr("srcset",newSrc);
            $(this).parent().parent().find("img").attr("data-srcset",newSrc);
              
            
          });

        }, 2000);

       }
     $(".pwAddToCart, .icon_cart").on("click", function(){
          pwSidebarCart();
       });
  
	if ($("body").hasClass("template-cart")){
      
      function replacePWimages(){
        
       var textArray = $(".cart_item .page_cart_info .mini_cart_body .mini_cart_meta:contains('PersonalisationID')");

          textArray.each(function() {

            var cardID = this.innerText.match(/PersonalisationID:.*/);
            cardID = cardID[0];
            cardID = cardID.replace("PersonalisationID:", "").trim();
            cardID = cardID.match(/[^\s]+/);
            cardID = cardID[0];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/270/"+cardID+".jpg?r="+rand;
            $(this).parent().parent().find("img").attr("src",newSrc);
            $(this).parent().parent().find("img").attr("srcset",newSrc);
            $(this).parent().parent().find("img").attr("data-srcset",newSrc);
              
            
          });
      }
		$(window).load(function(e) {
          
      		setTimeout(function(){ 
          		replacePWimages();
              }, 1500);
              
		});
      $(".cart__remove").on("click", function() {
         setTimeout(function(){ 
           replacePWimages();
         }, 1500);

      });


      $('#pw_modal').on('shown.bs.modal', function (e) {
          $("header").hide();
      });

      $("#pw_modal").on('hidden.bs.modal', function() { 
          $("header").show();
          $("body").css("top", 0);

          setTimeout(function(){ 
              replacePWimages();
          },1000);
      });
  }

});